var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0A7CC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24162 9.78369C6.95394 9.0242 8.09019 9.12643 8.5424 9.99072L8.87443 10.6245C9.17394 11.197 9.05319 11.9485 8.58146 12.4517C8.56905 12.4652 8.02155 13.0743 9.04728 14.1685C10.0842 15.2744 10.6567 14.6646 10.6567 14.6646C11.1283 14.1615 11.832 14.0337 12.3686 14.353L12.9633 14.7065C13.7737 15.1889 13.8699 16.4018 13.1576 17.1616C12.7296 17.6181 12.205 17.9732 11.6254 17.9966C10.6497 18.0361 8.99265 17.7724 7.33048 15.9995C5.6685 14.2267 5.42151 12.4593 5.45841 11.4185C5.48039 10.8002 5.8136 10.2402 6.24162 9.78369ZM16.9096 6.04541C17.1857 6.04548 17.4096 6.26931 17.4096 6.54541V7.32471C17.4096 8.0447 17.4108 8.63597 17.3471 9.10205C17.2812 9.58336 17.1374 10.0051 16.7953 10.3413C16.4543 10.6763 16.0283 10.8162 15.5424 10.8804C15.1256 10.9354 14.6094 10.9384 13.9897 10.939L14.8383 11.6069C15.0553 11.7775 15.0928 12.092 14.9223 12.3091C14.7516 12.5259 14.4372 12.5635 14.2201 12.3931L12.2367 10.8345C12.1164 10.7398 12.0464 10.5951 12.0463 10.4419C12.0463 10.2885 12.1162 10.1431 12.2367 10.0483L14.2201 8.48975C14.4371 8.31932 14.7516 8.35699 14.9223 8.57373C15.0928 8.79079 15.0552 9.10525 14.8383 9.27588L13.9936 9.93896C14.618 9.93815 15.0656 9.93482 15.4115 9.88916C15.7895 9.83923 15.9705 9.74976 16.0942 9.62842C16.2165 9.50825 16.3056 9.33418 16.3559 8.96729C16.4082 8.5847 16.4096 8.0737 16.4096 7.32471V6.54541C16.4096 6.26927 16.6334 6.04541 16.9096 6.04541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMessages);
export default __webpack_public_path__ + "static/media/info-messages.f3712480410a972fd6e6d1e68b1cc018.svg";
export { ForwardRef as ReactComponent };